import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import OldScreeningsList from './OldScreeningsList/OldScreeningsList';
import OldScreeningsTktSync from './OldScreeningsTktSync/OldScreeningsTktSync';
import OldScreeningShow from './OldScreeningShow/OldScreeningShow';
import OldScreeningEdit from './OldScreeningEdit/OldScreeningEdit';
import OldScreeningDelete from './OldScreeningDelete/OldScreeningDelete';

const OldScreenings = ({ match }) => {
    return (
        <div className="OldScreenings">
            <ContainerWrapper container="legacyScreenings">
                <Route exact path={match.path} component={OldScreeningsList} />
                <Route exact path={`${match.url}/programmation/:programmationId?`} component={OldScreeningsList} />
                <Route exact path={`${match.url}/show/:screeningId`} component={OldScreeningShow} />
                <Route exact path={`${match.url}/edit/:screeningId`} component={OldScreeningEdit} />
                <Route exact path={`${match.url}/delete/:screeningId/:programmationId`} component={OldScreeningDelete} />
                <Route exact path={`${match.url}/tktsync`} component={OldScreeningsTktSync} />
            </ContainerWrapper>
        </div>
    );
}

export default OldScreenings;
